export default "__VITE_ASSET__aT$Si$_r__"